<template>
  <div>
    <DataGetter
      @dataAvailable="
        data => {
          fees = data
        }
      "
      :searchQuery="{ userId }"
      contentId="fees"
      eventToListen="fees_updated"
    />
    <!-- {{ fees }} -->
    <div class="flex items-center gap-4 overflow-auto w-full">
      <div class="border w-full rounded-lg min-w-max overflow-hidden">
        <div class="min-w-content">
          <div
            class="min-w-max w-full flex justify-between p-4 rounded-t-lg border-b"
          >
            <div class="w-[10rem] min-w-[10rem]">Désignation</div>
            <div class="w-[8rem] min-w-[8rem]">Détail</div>
            <div class="w-[13rem] min-w-[13rem]">Frais</div>
            <div class="w-[6rem] min-w-[6rem]"></div>
          </div>
        </div>
        <div v-for="(fee, i) in feesList" :key="i">
          <div
            class="full flex justify-between p-4"
            :class="{ 'bg-slate-50': i % 2 }"
          >
            <div class="w-[10rem] min-w-[10rem]">{{ fee.designation }}</div>
            <div class="w-[8rem] min-w-[8rem]">{{ fee.details }}</div>
            <div class="w-[13rem] min-w-[13rem]">
              <div v-if="typeof fee.customerFee == 'number'">
                Client: {{ fee.customerFee
                }}<span class="text-[#959595]">% </span>
              </div>
              <div v-if="typeof fee.merchandFee == 'number'">
                Marchand: {{ fee.merchandFee
                }}<span class="text-[#959595]">% </span>
              </div>
              <div v-if="typeof fee.fee == 'number'">
                Frais: {{ fee.fee }}<span class="text-[#959595]">% </span>
              </div>
            </div>
            <div class="w-[6rem] min-w-[6rem] flex">
              <button class="ml-auto flex gap-2" @click="editFee(fee)">
                <div class="w-6 h-6">
                  <img
                    class="w-full h-full"
                    src="@/assets/images/all/pen.svg"
                    alt=""
                  />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EventListener
      :events="['fees_updated', 'failed_to_update_fees']"
      @fees_updated="onFeesUpdated"
      @failed_to_update_fees="onFeesNotUpdated"
    />
  </div>
</template>

<script>
import DataGetter from '../utils/DataGetter.vue'
import EventListener from '../utils/EventListener.vue'

export default {
  components: { DataGetter, EventListener },
  props: {
    userId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fees: [],
    }
  },
  mounted() {},
  unmounted() {},
  methods: {
    async editFee(fee) {
      const fields = {
        customerFee: {
          label: 'Frais client (%)',
          placeHolder: '5',
          type: 'number',
          propertyName: 'customerFee',
          required: true,
          defaultValue: fee.customerFee,
          class: 'col-span-1',
          inputProps: { min: 0, max: 0, numberStep: '0.01' },
        },
        merchandFee: {
          label: 'Frais marchand (%)',
          placeHolder: '5',
          type: 'number',
          propertyName: 'merchandFee',
          required: true,
          defaultValue: fee.merchandFee,
          class: 'col-span-1',
          inputProps: { min: 0, max: 0, numberStep: '0.01' },
        },
        fee: {
          label: 'Frais appliqué (%)',
          placeHolder: '5',
          type: 'number',
          propertyName: 'fee',
          required: true,
          defaultValue: fee.fee,
          class: 'col-span-1',
          inputProps: { min: 0, max: 0, numberStep: '0.01' },
        },
      }
      const fieldsToUse = []
      if (typeof fee.customerFee == 'number')
        fieldsToUse.push(fields.customerFee)
      if (typeof fee.merchandFee == 'number')
        fieldsToUse.push(fields.merchandFee)
      if (typeof fee.fee == 'number') fieldsToUse.push(fields.fee)

      const prompt = await window.customPrompt({
        title: 'Modifier le frais',
        subTitle: `Entrez les nouveaux frais  `,
        formFields: fieldsToUse,
        successText: 'Enrégistrer',
        cancelText: 'Annuler',
      })
      if (!prompt.accepted) return null

      return this.saveFees(prompt.data, fee)
    },
    async saveFees(newData, fee) {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Sauvegarde en cours',
        body: 'Sauvegarde des frais en cours',
      })

      const feesToSave = []
      if (fee.rawCustomerFee) {
        feesToSave.push({
          ...fee.rawCustomerFee,
          profitFee: newData.customerFee,
          serviceFee: newData.customerFee,
          processorFee: 0,
        })
      }
      if (fee.rawMerchandFee) {
        feesToSave.push({
          ...fee.rawMerchandFee,
          profitFee: newData.merchandFee,
          serviceFee: newData.merchandFee,
          processorFee: 0,
        })
      }
      if (fee.rawFee) {
        feesToSave.push({
          ...fee.rawFee,
          profitFee: newData.fee,
          serviceFee: newData.fee,
          processorFee: 0,
        })
      }

      this.$Events.dispatchEvent('fees_update_available', feesToSave)
    },
    onFeesUpdated() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Frais sauvegardé',
        body: 'Sauvegarde des frais réussi',
      })
    },
    onFeesNotUpdated() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Frais non enrégistrés',
        body: 'La sauvegarde des frais a échoué, veuillez réessayer',
      })
    },
  },
  computed: {
    feesList() {
      const customerFeeMomo = this.fees.find(
        fee =>
          fee.operation == 'customerPayment' && fee.processor == 'mobileMoney',
      )
      const customerFeeCard = this.fees.find(
        fee => fee.operation == 'customerPayment' && fee.processor == 'card',
      )
      const merchandFeeMomo = this.fees.find(
        fee =>
          fee.operation == 'walletFundingForPayment' &&
          fee.processor == 'mobileMoney',
      )
      const merchandFeeCard = this.fees.find(
        fee =>
          fee.operation == 'walletFundingForPayment' && fee.processor == 'card',
      )

      const merchandTransferFee = this.fees.find(
        fee =>
          fee.operation == 'walletWithdrawal' && fee.processor == 'mobileMoney',
      )
      const merchandWithdrawalFee = this.fees.find(
        fee => fee.operation == 'walletWithdrawal' && fee.processor == 'bank',
      )

      return [
        {
          designation: 'Paiement client',
          details: 'Mobile money',
          customerFee: customerFeeMomo?.serviceFee,
          merchandFee: merchandFeeMomo?.serviceFee,
          rawCustomerFee: customerFeeMomo,
          rawMerchandFee: merchandFeeMomo,
        },
        {
          designation: 'Paiement client',
          details: 'Carte bancaire',
          customerFee: customerFeeCard?.serviceFee,
          merchandFee: merchandFeeCard?.serviceFee,
          rawCustomerFee: customerFeeCard,
          rawMerchandFee: merchandFeeCard,
        },
        {
          designation: 'Transfer Marchand',
          details: '',
          fee: merchandTransferFee?.serviceFee,
          rawFee: merchandTransferFee,
        },
        {
          designation: 'Reversement',
          details: '',
          fee: merchandWithdrawalFee?.serviceFee,
          rawFee: merchandWithdrawalFee,
        },
      ]
    },
  },
  watch: {},
}
</script>
